<template>
    <div class="modal fade favourite-item-modal custom-modal" id="favourite_item_modal" tabindex="-1" role="dialog" aria-hidden="true" data-keyboard="false">
        <div class="top-modal-mask" data-dismiss="modal" aria-label="Close">
        </div>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-content custom-modal-content">
                    <div class="modal-header custom-modal-header">
                        <i class="fad fa-star"></i>
                        <h5 class="modal-title"> Salveaza la favorite </h5>
                    </div>
                    <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                        <i class="fad fa-times-circle"></i>
                    </div>
                    <div class="modal-body custom-modal-body">
                        <div class="create-message-container">
                            <div class="input-container">
                                <div class="input-group mg-b">
                                    <textarea name="description" v-model="notes" id="favrourite_item_note" placeholder="Scrie o notita...(optional)"></textarea>
                                    <div class="input-icon">
                                        <i class="fad fa-comment-alt-lines"></i>
                                    </div>
                                    <label class="custom-label" for="favrourite_item_note"> Notita </label>
                                </div>
                                <p class="custom-input-error"></p>
                            </div>
                            <div class="center-content mt-3">
                                <button type="button" name="button" class="general-btn positive-btn" @click="addToFavorites()">
                                    <i class="fad fa-paper-plane"></i>
                                    <span> Salveaza </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'FavouriteItemModal',
    data() {
      return {
        id: null,
        type: null,
        notes: null,
        projectId: null
      }
    },
    mounted() {
      let vm = this
      $('#favourite_item_modal').on('hidden.bs.modal', function () {
        vm.id = null
        vm.type = null
        vm.notes = null;
        vm.projectId = null;
      });
      this.$eventBus.$on('OPEN_FAV_MODAL', function (payLoad) {
        vm.id = payLoad.id;
        vm.type = payLoad.type;
        vm.projectId = (payLoad.type === 'model') ? payLoad.projectId : payLoad.id;
        $('#favourite_item_modal').modal('show')
      });
    },
    methods: {
      addToFavorites() {
        let vm = this
        this.triggerLoader(true)
          window.axios.get('/ajax/check-login')
              .then(function (response) {
                  let loggedIn = response.data.data;
                  if(loggedIn) {
                      window.axios.post(`/ajax/favorites/${vm.id}/${vm.type}`, {
                          notes: vm.notes
                      })
                          .then(function (response) {
                              let tip = 'Proiectul ';
                              if (vm.type === 'model') {
                                  tip = 'Modelul ';
                              }
                              window.Swal.fire({
                                  position: 'top-end',
                                  icon: 'success',
                                  html: tip+'a fost adaugat in lista de favorite.',
                                  showConfirmButton: false,
                                  timer: 1500
                              })
                              vm.id = vm.type = vm.notes = null;
                              $('#favourite_item_modal').modal('hide')
                              vm.$eventBus.$emit('SAVED_FAVORITES', {
                                  fav: response.data.data
                              });
                              vm.triggerLoader(false)
                          })
                          .catch(function (err) {
                              window.showError(err)
                              vm.triggerLoader(false)
                          });
                  } else {
                      let favorites = window.getLocalFavorites();
                      let newFavorite = null;
                      if(vm.type === 'model') {
                          let exists = favorites.filter(favorite => favorite.favoritable_type == 'App\\ProjectModel' && favorite.favoritable_id === vm.id)
                          if(!exists.length) {
                              newFavorite = {
                                  favoritable_id: vm.id
                                  ,favoritable_type: 'App\\ProjectModel'
                                  ,notes: vm.notes
                                  ,projectId: vm.projectId
                              };
                          }
                      } else {
                          let exists = favorites.filter(favorite => favorite.favoritable_type == 'App\\Project' && favorite.favoritable_id === vm.id)
                          if(!exists.length) {
                              newFavorite = {
                                  favoritable_id: vm.id
                                  ,favoritable_type: 'App\\Project'
                                  ,notes: vm.notes
                              };
                          }
                      }
                      favorites.push(newFavorite);
                      window.saveLocalFavorites(favorites);

                      let tip = 'Proiectul ';
                      if (vm.type === 'model') {
                          tip = 'Modelul ';
                      }
                      window.Swal.fire({
                          position: 'top-end',
                          icon: 'success',
                          html: tip+'a fost adaugat in lista de favorite.',
                          showConfirmButton: false,
                          timer: 1500
                      })
                      vm.id = vm.type = vm.notes = null;
                      $('#favourite_item_modal').modal('hide')
                      vm.$eventBus.$emit('SAVED_FAVORITES', {
                          fav: newFavorite
                      });
                      vm.triggerLoader(false)
                  }
              })
              .catch(function (err) {
                  console.log('err', err);
                  window.showError(err)
                  vm.triggerLoader(false)
              });

      },
    }
  }
</script>
